import React, {FunctionComponent, useState} from "react";
import {useSelector} from "react-redux";
import Popover from "@mui/material/Popover";
import {FiInfo} from "react-icons/fi";

import {isLoadingSelector} from "../../../../store/ducks/requirementList/selectors";

import IconButtonComponent from "../../../../components/IconButton";

import {statusColors} from "../RequirementListTable/style";
import {LEGENDS} from "./constants";
import {Wrapper, LegendContentWrapper, Legend, LegendWrapper} from "./style";

type LegendItemProps = {
  label: string;
  keyId: string
}

export const LegendItem: FunctionComponent<LegendItemProps> = ({label, keyId}) => {
  return (
    <LegendWrapper>
      <Legend data-testid={keyId} legendColor={statusColors.get(keyId)} />
      <label>{label}</label>
    </LegendWrapper>
  );
};

export function RequirementLegend() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  
  const onOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);

  const isListLoading = useSelector(isLoadingSelector);

  if (isListLoading) {
    return null;
  }

  return (
    <Wrapper>
      <IconButtonComponent icon={FiInfo} onClick={onOpen} />
      <Popover open={isOpen} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{vertical: "top", horizontal:"right" }}>
        <LegendContentWrapper>
          {LEGENDS.map(({keyId, label}) => <LegendItem label={label} key={keyId} keyId={keyId} />)}
        </LegendContentWrapper>
      </Popover>
    </Wrapper>
  );
}